export const newPassForm = [
    {
        cols: [
            {
                formGroup: 'newPassForm',
                class: 'col-12 col-lg-10',
                title: 'Perfecto. Introduce la nueva contraseña',
                titleClass: 'form-title text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 mx-auto col-lg-5',
                item: 'input',
                type: 'password',
                placeholder: 'Contraseña',
                inputClass: 'text-input',
                formControlName: 'password',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 mx-auto col-lg-5',
                item: 'input',
                type: 'password',
                placeholder: 'Repetir contraseña',
                inputClass: 'text-input',
                formControlName: 'confirmPassword',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 col-lg-5',
                item: 'button',
                type: 'regular',
                placeholder: 'Aceptar',
                inputClass: 'form-button btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
];
